import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 20l6.5 -9","key":"svg-0"}],["path",{"d":"M19 20c-6 0 -6 -16 -12 -16","key":"svg-1"}]]

/**
 * IconLambda
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGFtYmRhIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik02IDIwbDYuNSAtOSIgLz4KICA8cGF0aCBkPSJNMTkgMjBjLTYgMCAtNiAtMTYgLTEyIC0xNiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/lambda
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLambda = createReactComponent('outline', 'lambda', 'Lambda', __iconNode);

export default IconLambda;